import { useMutation } from "react-query";
import { validateTask } from "shared/taskState";

export const useCoderRejectValidation = () => {
    return useMutation(({ taskKey, isRejection, override }) =>
        validateTask(taskKey, override, null, isRejection).then((data) => {
            return data;
        }),
    );
};
